import
{
    FC,
    FormEvent,
    useState
} from "react";

import
{
    MenuToggleProps
} from "../types";

import
{
    RouteParams,
    useNamedRoutes
} from "../../NamedRoutes";

import System from "./System";

import
{
    IonButton,
    IonInput,
    IonItem,
    IonLabel
} from "@ionic/react";

import
{
    usePersistentState
} from "../../Persistence";


import
{
    useMyDetails,
    useMyPermissions
} from "../../Login/LoginProvider";

import
{
    permissionAllowed
} from "@ews/react-data";

import
{
    useAlert
} from "../../Dialog";

import
{
    useL10n
} from "@ews/react-localization-context";

import
{
    MenuItem
} from "./Sidebar";

import Icon from "@ews/react-icons";
import
{
    ReactClickEvent
} from "../../types";

import style from './Main.module.scss';
import { floatingPromiseHandler } from "../../../utils";

type MenuToggleEvent = ReactClickEvent;

type SidebarProps = MenuToggleProps & {
    routeParams?: RouteParams;
    title?: string;
};

export type AcquireAuthorizationProps = MenuToggleProps & {
    systemId: string;
};


export const PlanAuthorization: FC<AcquireAuthorizationProps> = ({
    onMenuToggle,
    systemId
}) =>
{
    const [authorized, _setAuthorized] = usePersistentState<boolean>("authorizationLevelPlan", false, systemId);
    const [code, setCode] = useState("");
    const { translate: t } = useL10n();
    const permissions = useMyPermissions();
    const details = useMyDetails();
    const alert = useAlert();

    const showMessage = async (message: string) =>
    {
        await alert({
            "title": t("[REACT_AUTHORIZATION_FAILED]"),
            "message": t(message),
            "buttonTitle": t('COM_BANNERS_CANCEL'),
            cssClass: style.cancelButton,
            buttonId: "cancel"
        });
    };

    const setAuthorized = (authorized: boolean) =>
    {
        _setAuthorized(authorized);
        setCode("");
        onMenuToggle && onMenuToggle({} as unknown as MenuToggleEvent);
    };


    const handleForm = async (e: FormEvent) =>
    {
        e.preventDefault();
        if (code === details.codeLevel3) {
            setAuthorized(true);
        } else {
            showMessage("[REACT_AUTHORIZATION_CODE_INVALID]").catch(floatingPromiseHandler(import.meta.url));
            setAuthorized(false);
        }
    };

    if (authorized) {
        return (
            <IonItem detail={false} onClick={() => setAuthorized(false)} button={true} >
                <IonLabel>{t('[REACT_EXIT_AUTHORIZATION_(PLAN)]')}</IonLabel>
                <Icon icon={`icon_Plan_unlocked`} />
            </IonItem>
        );
    }

    if (permissionAllowed(permissions.permitAccessLevel3!)) {
        return <form onSubmit={(e) => handleForm(e)}>
            <MenuItem>
                <IonLabel position="stacked">{t('[REACT_AUTHORIZATION_PLAN]')}</IonLabel>
                <IonInput value={code} onIonInput={(e) => setCode(e.detail.value || "")} label="" placeholder={t('[REACT_ENTER_CODE]')} />
                <IonButton type='submit' color={'light'} slot="end"><Icon icon={"icon_Plan_unlocked"} /></IonButton>
            </MenuItem >
        </form>;
    }

    return <></>;

};

const SystemPlan: FC<SidebarProps> = ({
    onMenuToggle,
    routeParams,
    title
}) =>
{
    const { params } = useNamedRoutes();

    return <System routeParams={routeParams} title={title} onMenuToggle={onMenuToggle}>
        <PlanAuthorization systemId={params().id || ""} onMenuToggle={onMenuToggle} />
    </System>;
};

export default SystemPlan;
